function linkNav(link) {
	link = link.target.getAttribute('href');
	if (link.substring(0, 2) === '/#') {
		link = link.substring(2);
	}

	let section = document.getElementById(link);
	section.scrollIntoView();
}


$(document).ready(function () {
	$(document).on('click', '.vg-nav-content li a', function (e) {
		linkNav(e)
	})
});